import Home from '@/views/Showcase/Home.vue';
import Features from '@/views/Showcase/Features.vue';
import Contact from '@/views/Showcase/Contact.vue';
import Blog from '@/views/Showcase/Blog.vue';
import Pricing from '@/views/Showcase/Pricing.vue';
import Account from '@/views/Showcase/Account.vue';
import Payment from '@/views/Showcase/Payment/Payment.vue';
import PaymentConfirmation from '@/views/Showcase/Payment/PaymentConfirmation.vue';
import PaymentSummary from '@/views/Showcase/Payment/PaymentSummary.vue';

export const showcaseRoutes = [
  { path: '/', component: Home, name: 'ShowcaseHome' },
  { path: '/features', component: Features, name: 'ShowcaseFeatures' },
  { path: '/contact', component: Contact, name: 'ShowcaseContact' },
  { path: '/blog', component: Blog, name: 'ShowcaseBlog' },
  { path: '/pricing', component: Pricing, name: 'ShowcasePricing' },
  { path: '/account', component: Account, name: 'ShowcaseAccount', meta: { requiresAuth: true } },
  { path: '/payment', component: Payment, name: 'ShowcasePayment', meta: { requiresAuth: true } },
  { path: '/payment/confirmation', component: PaymentConfirmation, name: 'ShowcasePaymentConfirmation', meta: { requiresAuth: true } },
  { path: '/payment/summary', component: PaymentSummary, name: 'ShowcasePaymentSummary', meta: { requiresAuth: true } },
];